import posthog from "posthog-js"
import { trackingService } from "utils/tracking"
import { HubSpotTrackingEvents, TrackingEvents } from "utils/tracking/events"

const ORIGIN_PRODUCT = "pgctl"

export const PGCTL_PRODUCT_REGISTRATION_AMOUNTS: Record<string, number> = {
  "pgctl-professional": 105000,
  "pgctl-executive": 260000,
}

const identifyOnTrackingProviders = (email: string) => {
  if (!email) return
  try {
    posthog?.identify("", { email })
  } catch (e) {
    console.warn("PostHog identify failed", e)
  }
  try {
    if (typeof window !== "undefined" && window._hsq) {
      window._hsq.push(["identify", { email }])
    }
  } catch (e) {
    console.warn("HubSpot identify failed", e)
  }
}

export const trackPgctlRegistrationStarted = ({
  email,
  totalAmount,
}: {
  email: string
  totalAmount: number
}) => {
  identifyOnTrackingProviders(email)

  const data = {
    email,
    total_amount: totalAmount,
    origin_product: ORIGIN_PRODUCT,
  }

  trackingService.trackEvent(
    TrackingEvents.pgctlSelfEnrollRegistrationStarted,
    data,
    { services: ["PostHog"] }
  )
  trackingService.trackEvent(
    HubSpotTrackingEvents.pgctlSelfEnrollRegistrationStarted,
    data,
    { services: ["HubSpot"] }
  )
}

export const trackPgctlRegistrationEnded = ({
  email,
  transactionId,
  status,
}: {
  email: string
  transactionId: string
  status: "success" | "failed" | "cancelled"
}) => {
  identifyOnTrackingProviders(email)

  const data = {
    email,
    transaction_id: transactionId,
    status,
    origin_product: ORIGIN_PRODUCT,
  }

  trackingService.trackEvent(
    TrackingEvents.pgctlSelfEnrollRegistrationEnded,
    data,
    { services: ["PostHog"] }
  )
  trackingService.trackEvent(
    HubSpotTrackingEvents.pgctlSelfEnrollRegistrationEnded,
    data,
    { services: ["HubSpot"] }
  )
}
